import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mb-1" }, "Pharmacy", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "ms-3 mt-3 card card-body p-3"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<p><span class=\"shimmer-loading block-size-6\"></span></p><p><span class=\"shimmer-loading block-size-4\"></span></p><p><span class=\"shimmer-loading block-size-8\"></span></p><p><span class=\"shimmer-loading block-size-6\"></span></p><p><span class=\"shimmer-loading block-size-4\"></span></p>", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = {
  key: 1,
  class: "mt-2 card p-2 d-flex flex-column"
}
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "d-flex mb-1" }
const _hoisted_13 = { class: "d-flex mb-1" }
const _hoisted_14 = { class: "me-1" }
const _hoisted_15 = {
  key: 0,
  class: "me-1"
}
const _hoisted_16 = { class: "me-1" }
const _hoisted_17 = { class: "me-1" }
const _hoisted_18 = { class: "me-1" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex mb-1"
}
const _hoisted_20 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormatName = _resolveComponent("FormatName")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TypeaheadInput, {
      getData: _ctx.getPharmacyList,
      value: _ctx.pharmacy,
      placeholder: "Start Typing...",
      onValueChanged: _ctx.pharmacyChanged
    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"]),
    (_ctx.loadingPharmacyDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_9))
      : _createCommentVNode("v-if", true),
    (!_ctx.loadingPharmacyDetails && _ctx.pharmacyDetails.Id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.pharmacyDetails.Name), 1 /* TEXT */),
          _createElementVNode("section", _hoisted_12, [
            _createVNode(_component_FormatName, {
              "first-name": _ctx.pharmacyDetails.ContactFirstName,
              "last-name": _ctx.pharmacyDetails.ContactLastName
            }, null, 8 /* PROPS */, ["first-name", "last-name"])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.pharmacyDetails.Address.addressLine1) + ",", 1 /* TEXT */),
            (_ctx.pharmacyDetails.Address.addressLine2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.pharmacyDetails.Address.addressLine2) + ", ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.pharmacyDetails.Address.city) + ",", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.pharmacyDetails.Address.state), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatZipCode(_ctx.pharmacyDetails.Address.zipCode)), 1 /* TEXT */)
          ]),
          (_ctx.pharmacyDetails.PhoneNumbers)
            ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(_ctx.pharmacyDetails.PhoneNumbers[0].number)) + " ", 1 /* TEXT */),
                  (_ctx.pharmacyDetails.PhoneNumbers[1] && _ctx.pharmacyDetails.PhoneNumbers[1].number)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" , " + _toDisplayString(_ctx.formatPhoneNumber(_ctx.pharmacyDetails.PhoneNumbers[1].number)), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.pharmacyDetails.Email)
            ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
                _createElementVNode("span", null, _toDisplayString(_ctx.pharmacyDetails.Email), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}